var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDevelopmentplan(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2891 1.25977H15.5V20H0.5V1.25977H1.73047V0H2.98047V1.25977H5.5V0H6.75V1.25977H9.26953V0H10.5195V1.25977H13.0391V0H14.2891V1.25977ZM14.25 18.75V2.50977H1.75V18.75H14.25ZM11.75 5.00977V6.25977H4.25V5.00977H11.75ZM4.25 16.2695V15.0195H11.75V16.2695H4.25ZM4.25 11.2598V10.0098H11.75V11.2598H4.25Z",
    fill: "#D12232"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevelopmentplan);
export default __webpack_public_path__ + "static/media/developmentplan.5d42270cf734122d8721652c99f3f6cd.svg";
export { ForwardRef as ReactComponent };